var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(_vm.i18n != null)?_c('I18nUpdater',{attrs:{"i18nGroupName":_vm.i18nGroupName},on:{"i18nChangeState":_vm.onI18nChangeState}}):_vm._e(),(_vm.i18n != null)?_c('router-view'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }